import { Component, Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserManagementDeleteDialogComponent } from 'app/main/user-management/user-management-delete-dialog/user-management-delete-dialog.component';
import { IUser } from 'app/models/user-management.model';

@Injectable({ providedIn: 'root' })
export class UserManagementDeleteDialogService {
  private isOpen = false;

  constructor(private modalService: NgbModal) {
  }

  open(user: IUser): NgbModalRef {
    this.isOpen = true;
    const modalRef = this.modalService.open(UserManagementDeleteDialogComponent as Component, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.user = user;
    modalRef.result.then(
      () => {
        this.isOpen = false;
      },
      () => {
        this.isOpen = false;
      }
    );
    return modalRef;
  }
}
